import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";

/**
 * Generated class for the DataProcessModuleLogsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
  selector: 'page-data-process-module-logs',
  templateUrl: 'data-process-module-logs.html',
})
export class DataProcessModuleLogsPage {

  School='GEIS';
  SchoolId=1;

  Status='All';
  StatusId=0;
  DisplayDate='';
  FilterOption = 'All';
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  Date: any;

  displayData:any[];


  constructor(public navCtrl: NavController, public navParams: NavParams,
              public service:ServiceProvider,public loadingCtrl:LoadingController)
  {
    this.Date = new Date();
    this.DisplayDate = this.Date.getDate() + "-" + this.monthNames[this.Date.getMonth()] + "-" + this.Date.getFullYear();
    this.Date = this.Date.toISOString();

    this.getValues(0);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DataProcessModuleLogsPage');
  }


  active_tab(tab,Id) {
    console.log(tab);
    this.School = tab;
    this.SchoolId=Id;
    this.getValues(0);
  }


  active_Staus_tab(tab,Id) {
    console.log(tab);
    this.Status = tab;
    this.StatusId=Id;
    this.getValues(0);
  }

  add_filter(f) {
    console.log(f);
    if (f == 'All') {
      this.FilterOption = 'All';
      this.DisplayDate = "";
      this.StatusId=0;
      this.getValues(0);

    } else {
      this.FilterOption = 'Date';
      var Date1 = new Date(this.Date);
      console.log(Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear());
      this.DisplayDate = Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear();
      console.log("DisplayDate ", this.DisplayDate);
      console.log('Date call');
      this.getValues(this.DisplayDate);
    }

  }

  Prev(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) - 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }

  Next(date) {
    this.Date = new Date(date);
    this.Date.setDate(this.Date.getDate(date) + 1);
    this.Date = this.Date.toISOString();
    //in this case ion-datetime will call ionChange event
  }


  getValues(date)
  {
    let load=this.loadingCtrl.create({
      content:'Loading...'
    });
    load.present();

    setTimeout(() => {
     load.dismiss();
    }, 3000);

    this.service.httppostcall('app_web_service/get_process_logs?SchoolId='+this.SchoolId+'&FStatusId='+this.StatusId+'&date='+date,'').subscribe(data=>{
      load.dismiss();
      this.displayData=data['DisplayData'];
      });
  }


  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.getValues(0);

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

}



// WEBPACK FOOTER //
// ./src/pages/data-process-module-logs/data-process-module-logs.ts